import { render, staticRenderFns } from "./FigureDetails.vue?vue&type=template&id=66c1bba5&"
import script from "./FigureDetails.vue?vue&type=script&lang=js&"
export * from "./FigureDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-cli-plugin-import-components */
const vueCliInstallComponent = require("!../../node_modules/vue-cli-plugin-import-components/dist/runtime/installComponents.js")
import Breadcrumb from "@/components/breadcrumb.vue";
import Dropdown from "@/components/visualizer/dropdown.vue";
import EditAnimation from "@/components/editAnimation.vue";
import EditFigure from "@/components/editFigure.vue";
import Player from "@/components/player/Player.vue";
import PrecedesFollows from "@/components/visualizer/precedesFollows.vue";
import SegmentedControl from "@/components/segmentedControl.vue";
import StepTableVideo from "@/components/visualizer/stepTableVideo.vue";
import Visualizer from "@/components/visualizer/visualizer.vue";
vueCliInstallComponent(component, {Breadcrumb, Dropdown, EditAnimation, EditFigure, Player, PrecedesFollows, SegmentedControl, StepTableVideo, Visualizer});